export const REFRESH_AUTHENTICATED_USER = 'refreshAuth';
